<template>
    <div class="mob-map-trigger">
        <div class="city-map-cta">
            <div class="map-wrap" id="map" ref="mapElement" style="height: 100%;">
            </div>
            <div id="map-cta" class="map-wrap">
                <div class="content">
                    <svg class="location-pin"><use xlink:href="#location-pin"></use></svg>
                    <span>Open Map</span>
                    <svg class="arrow-down"><use xlink:href="#arrow-down"></use></svg>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ctaStyles from '@/classes/mapStyles';

    export default {

        props: ['spots'],

        data() {
            return {
                city: (this.spots & this.spots.length > 0 && this.spots[0].city) ? this.spots[0].city : null,
                google: null,
                map: null,
                mapStyles: ctaStyles,
            }
        },

        async mounted() {
            eventBus.$on('google-api-is-ready', api => {
                this.google = api
            })
            $('.mob-map-trigger').on('click', function () {
                $(this).slideUp(function () {
                    $('.map-main').addClass('show')
                    $('.mob-map-controls').addClass('show')
                    $('#mob-map-trigger').addClass('active')
                })
                $('body').addClass('no-scroll no-touch')
            })
            $('.mob-map-controls span').on('click', function () {
                $(this)
                    .addClass('active')
                    .siblings()
                    .removeClass('active')

                if ($(this).data('target') == 'map') {
                    $('.map-main').addClass('show')
                    $('body').addClass('no-scroll no-touch')
                } else {
                    $('.map-main').removeClass('show')
                    $('body').removeClass('no-scroll no-touch')
                }
            })
            this.$nextTick(() => {
                this.initializeMap()
            })
        },

        methods: {

            initializeMap() {
                if(this.city == null) {
                    return
                }

                const geocoder = new this.google.maps.Geocoder();

                geocoder.geocode({'address': this.city.slug}, (res, status) => {

                    const mapContainer = this.$refs.mapElement;

                    const mapOptions = {
                        zoom: 13,
                        styles: ctaStyles,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        streetViewControl: false,
                        zoomControl: false,
                        disableDefaultUI: true
                    }

                    if (status === 'OK') {
                        this.map = new this.google.maps.Map(mapContainer, mapOptions)
                        this.map.setCenter(res[0].geometry.location);
                        document.getElementById("map").replaceWith(mapContainer);
                    }
                })
            }
        },

        watch: {
            spots() {
                this.city = (this.spots.length && this.spots[0].city) ? this.spots[0].city : null
                this.initializeMap();
            }
        }
    }
</script>
